export default __webpack_public_path__ + "static/media/Ballroll_00319.248d2a76.png";